import "@assets/css/bootstrap-grid.css";
import { EyeClosedIcon } from "@assets/icons/index";
import { Spinner } from "@components/ui/spinner";
import { zodResolver } from "@hookform/resolvers/zod";
import { endpoint } from "@services/api.services";
import { getInputField } from "@utils/function/index.function";
import {
  encryptData,
  showToast,
  throwErrorAlert,
} from "@utils/helper/index.helper";
import { FormField } from "@utils/interface/form.interface";
import { UserFormData, UserLoginSchema } from "@utils/interface/form.schema";
import { METHODS } from "@utils/interface/index.interface";
import { usePostData } from "@utils/query/index.query";
import { useSelectionStore } from "@utils/states/index.state";
import { se } from "date-fns/locale";
import Cookies from "js-cookie";
import { Eye } from "lucide-react";
import React, { useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { NavLink, useNavigate } from "react-router";
const LoginForm: React.FC = () => {
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    formState: { errors },
  } = useForm<UserFormData>({
    mode: "onChange",
    resolver: zodResolver(UserLoginSchema),
  });

  /* set default value */
  const navigate = useNavigate();
  const { mutate, isPending } = usePostData();

  const handleMutate = (data: any) => {
    return {
      data,
      endpoint: endpoint["auth"]["login"],
      method: METHODS.POST,
    };
  };
  const handleSuccess = async ({ data, status }: any) => {
    if ([200].includes(status)) {
      if (watch("isRemember")) {
        Cookies.set("access", data.access, {
          expires: new Date(Date.now() + 1000 * 60 * 60 * 24), // 1 day
        });
        Cookies.set("refresh", data.refresh, {
          expires: new Date(Date.now() + 1000 * 60 * 60 * 24), // 1 day
        });
      } else {
        sessionStorage.setItem("access", data.access);
        sessionStorage.setItem("refresh", data.refresh);
      }
      showToast({
        title: "Login Success",
        description: "Welcome To Skill Shikhshya",
        type: "success",
      });
      navigate("/journey?tpage=1");
    }
    if (status !== 200) {
      showToast({
        title: "Login failed",
        description: status === 401 ? "Unauthorized" : "Login mismatched",
        type: "error",
      });
      throw new Error("Unknown API Error");
    }
  };
  const { setIsFormPending } = useSelectionStore();
  const handleError = async (error: any) => {
    console.log(error.data, "error00");
    if (error?.data?.status == 413) {
      showToast({
        description: "File Size Too Large",
        type: "error",
        title: "Error",
      });
    }
    setIsFormPending(false);
    const errorMessage = error.data.response.data;
    console.log(errorMessage, "Error Message");

    throwErrorAlert(errorMessage);
  };

  const [showPassword, setShowPassword] = useState(false);
  const onSubmit: SubmitHandler<UserFormData> = (data) => {
    mutate(handleMutate(data), {
      onSuccess: ({ data, status }) => handleSuccess({ data, status }),
      onError: (data) => handleError({ data }),
    });
    Cookies.set("email", encryptData(data.email));
    // navigate("/journey");
  };

  const formSchema: FormField[] = [
    {
      name: "email",
      label: "Email Address",
      colSpan: 12,
      type: "text",
      placeholder: "xyz@vrittechnologies.com",
      validation: { required: "Name is required" },
      control: control,
      setValue: setValue,
      errors,
      className: `mb-[20px] min-w-full w-full`,
      visable: true,
    },
    {
      name: "password",
      label: "Password",
      colSpan: 12,
      type: showPassword ? "text" : "password",
      placeholder: "***********************",
      validation: { required: "password is required" },
      endIcon: (
        <>
          {showPassword ? (
            <Eye
              size={17}
              color="#ABABAB"
              onClick={() => setShowPassword(!showPassword)}
            />
          ) : (
            <span onClick={() => setShowPassword(!showPassword)}>
              <EyeClosedIcon />
            </span>
          )}
        </>
      ),

      control: control,
      setValue: setValue,
      errors,
      className: `mb-[20px] min-w-full w-full`,
      visable: true,
    },

    {
      name: "isRemember",
      label: "Remember Me",
      colSpan: 6,
      type: "checkbox",
      validation: { required: "Name is required" },
      control: control,
      setValue: setValue,
      errors,
      className: `me-2 select-none`,
      visable: true,
    },
    {
      colSpan: 6,
      type: "component",
      component: <NavLink to={"/forget-password"}>Forgot Password?</NavLink>,
      className: `text-[#1DA077] text-[14px] font-[500] flex items-center mt-1 text-end`,
    },
    {
      type: "submit",
      value: "Login",
      className: "w-full h-[47px] mt-[32px]",
      colSpan: 12,
      variant: "default",
      endIcon: isPending ? <Spinner /> : null,
      disabled: isPending ? true : false,
      visable: true,
    },
  ];

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} className="row max-w-[424px]">
        {formSchema.map(
          (field, index) =>
            (field.visable || field.visable == undefined) && (
              <div
                key={index}
                className={`col-lg-${field.colSpan} col-12 lg:px-[12px] px-[8px]`}
              >
                {getInputField({ ...field })}
              </div>
            )
        )}
      </form>
    </>
  );
};

export default LoginForm;
